var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/document-upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/document-upload_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 35.5C17.18 35.5 16.5 34.82 16.5 34V25.62L15.06 27.06C14.48 27.64 13.52 27.64 12.94 27.06C12.36 26.48 12.36 25.52 12.94 24.94L16.94 20.94C17.36 20.52 18.02 20.38 18.58 20.62C19.14 20.84 19.5 21.4 19.5 22V34C19.5 34.82 18.82 35.5 18 35.5Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22 27.4999C21.62 27.4999 21.24 27.3599 20.94 27.0599L16.94 23.0599C16.36 22.4799 16.36 21.5199 16.94 20.9399C17.52 20.3599 18.48 20.3599 19.06 20.9399L23.06 24.9399C23.64 25.5199 23.64 26.4799 23.06 27.0599C22.76 27.3599 22.38 27.4999 22 27.4999Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30 45.5H18C7.14 45.5 2.5 40.86 2.5 30V18C2.5 7.14 7.14 2.5 18 2.5H28C28.82 2.5 29.5 3.18 29.5 4C29.5 4.82 28.82 5.5 28 5.5H18C8.78 5.5 5.5 8.78 5.5 18V30C5.5 39.22 8.78 42.5 18 42.5H30C39.22 42.5 42.5 39.22 42.5 30V20C42.5 19.18 43.18 18.5 44 18.5C44.82 18.5 45.5 19.18 45.5 20V30C45.5 40.86 40.86 45.5 30 45.5Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44 21.5H36C29.16 21.5 26.5 18.84 26.5 12V3.99998C26.5 3.39998 26.86 2.83998 27.42 2.61998C27.98 2.37998 28.62 2.51998 29.06 2.93998L45.06 18.94C45.48 19.36 45.62 20.02 45.38 20.58C45.14 21.14 44.6 21.5 44 21.5ZM29.5 7.61998V12C29.5 17.16 30.84 18.5 36 18.5H40.38L29.5 7.61998Z",
    fill: "#777777"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUpload);
export default __webpack_public_path__ + "static/media/document-upload.1665760fe1653ae2857aed1fea54562a.svg";
export { ForwardRef as ReactComponent };